import AiBotTransferCasesAPI from 'dashboard/api/aiBot/transferCases';
import { throwErrorMessage } from '../../utils/api';

const types = {
  SET_UI_FLAG: 'SET_UI_FLAG',
  SET_RECORDS: 'SET_RECORDS',
  ADD_RECORD: 'ADD_RECORD',
  REPLACE_RECORD: 'REPLACE_RECORD',
  REMOVE_RECORD: 'REMOVE_RECORD',
};

export const state = {
  records: {},
  meta: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getRecords: $state => botId => $state.records[botId] || [],
  getUIFlags: $state => $state.uiFlags,
  getMeta: $state => $state.meta,
};

export const actions = {
  get: async ({ commit }, { botId }) => {
    commit(types.SET_UI_FLAG, { isFetching: true });
    try {
      const response = await new AiBotTransferCasesAPI(botId).get();
      commit(types.SET_RECORDS, { botId, records: response.data });
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, { botId, ...data }) => {
    commit(types.SET_UI_FLAG, { isCreating: true });
    try {
      const response = await new AiBotTransferCasesAPI(botId).create(data);
      commit(types.ADD_RECORD, { botId, record: response.data });
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { botId, id, ...data }) => {
    commit(types.SET_UI_FLAG, { isUpdating: true });
    try {
      const response = await new AiBotTransferCasesAPI(botId).update(id, data);
      commit(types.REPLACE_RECORD, { botId, record: response.data });
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, { botId, id }) => {
    commit(types.SET_UI_FLAG, { isDeleting: true });
    try {
      await new AiBotTransferCasesAPI(botId).delete(id);
      commit(types.REMOVE_RECORD, { botId, id });
      return id;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_RECORDS]($state, { botId, records }) {
    $state.records = { ...$state.records, [botId]: records };
  },
  [types.ADD_RECORD]($state, { botId, record }) {
    const records = $state.records[botId] || [];
    $state.records = { ...$state.records, [botId]: [...records, record] };
  },
  [types.REPLACE_RECORD]($state, { botId, record }) {
    const records = ($state.records[botId] || []).map(item =>
      item.id === record.id ? record : item
    );
    $state.records = { ...$state.records, [botId]: records };
  },
  [types.REMOVE_RECORD]($state, { botId, id }) {
    const records = ($state.records[botId] || []).filter(
      item => item.id !== id
    );
    $state.records = { ...$state.records, [botId]: records };
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
